import React from "react"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Button } from "primereact/button"
import styles from "../../styles/FilterHeader.module.css"

const FilterHeaderUserAccounts = ({
  filters,
  clearAllFilters,
  onFilterData,
}) => {
  const [isExpanded, setIsExpanded] = React.useState(true)
  const toggleExpand = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <div className={styles["filter-container"]}>
      <div className={styles["filter-header"]}>
        <h3>Filter Options</h3>
        <Button
          icon={isExpanded ? "pi pi-chevron-up" : "pi pi-chevron-down"}
          onClick={toggleExpand}
          className={styles["expand-button"]}
        />
      </div>
      {isExpanded && (
        <>
          <div className={styles["filter-fields"]}>
            {filters.map((filter, index) => (
              <div key={index} className={styles["filter-field"]}>
                {filter.label && (
                  <label style={{ marginRight: "5px" }}>{filter.label}:</label>
                )}
                {filter.type === "dropdown" ? (
                  <Dropdown
                    value={filter.value}
                    options={filter.options}
                    onChange={filter.onChange}
                    // onBlur={filter.onBlur} 
                    placeholder={filter.placeholder}
                    filter={filter.enableFilter}
                  />
                ) : (
<InputText
                    value={filter.value}
                    onChange={filter.onChange}
                    // onBlur={filter.onBlur}
                    onKeyDown={filter.onKeyDown}  
                    placeholder={filter.placeholder}
                  />
                )}
              </div>
            ))}
          </div>
          <div className={styles["filter-actions"]}>
            <Button
              label="Filter results"
              onClick={onFilterData}
              className={styles["apply-button"]}
            />
            <Button
              label="Reset Filters"
              icon="pi pi-refresh"
              onClick={clearAllFilters}
              className={styles["clear-button"]}
            />
          </div>
        </>
      )}
    </div>
  )
}

export default FilterHeaderUserAccounts
